import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DecathlonResultTable } from './page_ResultTable/DecathlonResultTable';
import { DecathlonInputTable } from './page_ResultTable/components/DecathlonInputTable';
import { DemoDecathlonRankingTable } from './page_ResultTable/components/DemoDecathlonRankingTable';
import { CalculatorIndoorHeptathlon } from './page_calculator/CalculatorIndoorHeptathlon';
import { CalculatorIndoorPentathlon } from './page_calculator/CalculatorIndoorPentathlon';
import { PointGapsList } from './page_pointGapList/PointGapList';
import { VariousCombinedEventsRecord } from './page_VariousCombinedEventsRecord/VariousCombinedEventsRecord';
import { HeptathlonResultTable } from './page_ResultTable/HeptathlonResultTable';
import { U20DecathlonResultTable } from './page_ResultTable/U20DecathlonResultTable';
import { U20HeptathlonResultTable } from './page_ResultTable/U20HeptathlonResultTable';
import { CalculatorDecathlonSave } from './page_calculator/CalculatorDecathlonSave';
import { CalculatorHeptathlonSave } from './page_calculator/CalculatorHeptathlonSave';
import { CalculatorOctathlonSave } from './page_calculator/CalculatorOctathlonSave';
import { CalculatorTetrathlonManSave } from './page_calculator/CalculatorTetrathlonManSave';
import { CalculatorTetratathlonWomanSave } from './page_calculator/CalculatorTetrathlonWomanSave';
import { TopPage } from './page_top/topPage';
import { RankingScore } from './page_RankingScore/RankingScore';
import ResettableModal from './test';
import { PrivacyPolicy } from './page_Privacy/Privacy';
import { RankingScoreAllEvent } from './page_RankingScore/RankingScoreAllEvent';
import { CalculatorDecathlonCompare } from './page_calculator/CalculatorDecathlonCompare';
import { CalculatorHeptathlonCompare } from './page_calculator/CalculatorHeptathlonCompare';
import { CalculatorOctathlonCompare } from './page_calculator/CalculatorOctathlonCompare';
import { CalculatorTetrathlonManCompare } from './page_calculator/CalculatorTetrathlonManCompare';
import { CalculatorTetrathlonWomanCompare } from './page_calculator/CalculatorTetrathlonWomanCompare';
import { DecathlonResultTableEn } from './page_ResultTable/DecathlonResultTableEn';
import { HeptathlonResultTableEn } from './page_ResultTable/HeptathlonResultTableEn';
import { CalculatorMastersDecathlonCompare } from './page_calculator/CalculatorMastersDecathlonCompare';
import { CalculatorMastersDecathlonSave } from './page_calculator/CalculatorMastersDecathlonSave';

function App() {
  return (
    <>
      <ChakraProvider>
        <BrowserRouter>
          <Routes>
            <Route path={`/`} element={<TopPage />} />
            <Route path={`/test`} element={<ResettableModal />} />
            <Route path={`/dec`} element={<DecathlonResultTable />} />
            <Route path={`/hep`} element={<HeptathlonResultTable />} />
            <Route path={`/dec/en`} element={<DecathlonResultTableEn />} />
            <Route path={`/hep/en`} element={<HeptathlonResultTableEn />} />
            <Route path={`/U20dec`} element={<U20DecathlonResultTable />} />
            <Route path={`/U20hep`} element={<U20HeptathlonResultTable />} />
            <Route path={`/decathloninput`} element={<DecathlonInputTable />} />
            <Route path={`/demo`} element={<DemoDecathlonRankingTable />} />
            {/* <Route path={`/`} element={<CalculatorDecathlon />} /> */}
            <Route
              path={`/decathloncalculator`}
              element={<CalculatorDecathlonSave />}
            />
            <Route
              path={`/decathloncalculatorcompare`}
              element={<CalculatorDecathlonCompare />}
            />
            <Route
              path={`/heptathloncalculator`}
              // element={<CalculatorHeptathlon />}
              element={<CalculatorHeptathlonSave />}
            />
            <Route
              path={`/heptathloncalculatorcompare`}
              element={<CalculatorHeptathlonCompare />}
            />
            <Route
              path={`/octathloncalculator`}
              // element={<CalculatorOctathlon />}
              element={<CalculatorOctathlonSave />}
            />
            <Route
              path={`/octathloncalculatorcompare`}
              element={<CalculatorOctathlonCompare />}
            />
            <Route
              path={`/indoorheptathloncalculator`}
              element={<CalculatorIndoorHeptathlon />}
            />
            <Route
              path={`/indoorpentathloncalculator`}
              element={<CalculatorIndoorPentathlon />}
            />
            <Route
              path={`/tetrathlonmancalculator`}
              // element={<CalculatorTetrathlonMan />}
              element={<CalculatorTetrathlonManSave />}
            />
            <Route
              path={`/tetrathlonmancalculatorcompare`}
              // element={<CalculatorTetrathlonMan />}
              element={<CalculatorTetrathlonManCompare />}
            />
            <Route
              path={`/tetrathlonwomancalculator`}
              // element={<CalculatorTetratathlonWoman />}
              element={<CalculatorTetratathlonWomanSave />}
            />
            <Route
              path={`/tetrathlonwomancalculatorcompare`}
              // element={<CalculatorTetrathlonMan />}
              element={<CalculatorTetrathlonWomanCompare />}
            />{' '}
            <Route
              path={`/decathlonmasterscalculator`}
              element={<CalculatorMastersDecathlonSave />}
            />
            <Route
              path={`/decathlonmasterscalculatorcompare`}
              element={<CalculatorMastersDecathlonCompare />}
            />
            <Route path={`/decathlonlist`} element={<PointGapsList />} />
            <Route
              path={`/variousrecord`}
              element={<VariousCombinedEventsRecord />}
            />
            <Route path={`/rankingscore`} element={<RankingScore />} />
            <Route
              path={`/rankingscoreallevent`}
              element={<RankingScoreAllEvent />}
            />
            <Route path={`/privacy`} element={<PrivacyPolicy />} />
            <Route path={`/input`} element={<DecathlonInputTable />} />
          </Routes>
        </BrowserRouter>
      </ChakraProvider>
    </>
  );
}

export default App;
